import { DocumentGroupResponse } from '@/types/service-response'

export class DocumentGroup {
  public constructor (
    readonly id: number,
    readonly code: string | null,
    readonly bezeichnung: string | null,
    readonly label: string
  ) {}

  static createListFromResponse (responseData: DocumentGroupResponse[]): Array<DocumentGroup> {
    return responseData.map((item: DocumentGroupResponse ) => {
      return new DocumentGroup(
        item.ID,
        item.Code,
        item.Bezeichnung,
        `${item.Code ? item.Code : ''} ${item.Bezeichnung ? item.Bezeichnung : ''}`
      )
    })
  }
}
